module.exports = __webpack_public_path__ + "img/stand_boluo_tense_cut.c70e4c74.png";